(function () {
  'use strict';

  function decimal(raw) {
    var value = String(raw).trim().replace(',', '.');
    return /^\d+(?:\.\d+)?$/.test(value) ? Number(value) : NaN;
  }

  function helium(count, reserve) {
    if (!Number.isInteger(count) || count < 1 || count > 999 || [0, 5, 10, 15].indexOf(reserve) === -1) return null;
    var planned = Math.ceil(count * (100 + reserve) / 100);
    return { requested: count, reserve: reserve, planned: planned, tanks: Math.ceil(planned / 50) };
  }

  function decor(length, sample, count, reserve) {
    if (!Number.isFinite(length) || length <= 0 || length > 1000 || !Number.isFinite(sample) || sample <= 0 || sample > 1000 || !Number.isInteger(count) || count < 1 || count > 100000 || !Number.isInteger(reserve) || reserve < 0 || reserve > 100000) return null;
    var raw = length / sample * count;
    if (!Number.isFinite(raw) || raw > 1000000) return null;
    var base = Math.max(1, Math.ceil(raw - Number.EPSILON * Math.max(1, Math.abs(raw)) * 8));
    return { base: base, reserve: reserve, total: base + reserve };
  }

  function format(number) { return number.toLocaleString('nl-NL'); }
  function balloons(number) { return format(number) + (number === 1 ? ' ballon' : ' ballonnen'); }

  function field(form, name, valid, message) {
    var input = form.elements.namedItem(name);
    var error = form.querySelector('#' + input.id + '-error');
    input.setAttribute('aria-invalid', valid ? 'false' : 'true');
    if (error) {
      error.hidden = valid;
      error.textContent = valid ? '' : message;
    }
    return valid;
  }

  function enable(root) {
    if (root.dataset.bkCalculatorReady === 'true') return;
    var form = root.querySelector('form');
    var output = root.querySelector('output');
    if (!form || !output) return;
    var type = root.getAttribute('data-bk-calculator');
    if (type !== 'helium' && type !== 'decor') return;
    root.dataset.bkCalculatorReady = 'true';

    function number(name) { return decimal(form.elements.namedItem(name).value); }

    function update(event) {
      if (event && event.type === 'submit') event.preventDefault();
      var result, valid = true;
      if (type === 'helium') {
        var count = number('count');
        var reserve = number('reserve');
        valid = field(form, 'count', Number.isInteger(count) && count >= 1 && count <= 999, 'Vul een heel aantal van 1 tot en met 999 in.') && valid;
        valid = field(form, 'reserve', [0, 5, 10, 15].indexOf(reserve) !== -1, 'Kies geen extra ruimte, 5%, 10% of 15%.') && valid;
        result = valid ? helium(count, reserve) : null;
        if (result) {
          output.textContent = balloons(result.requested) + ' ' + (result.reserve ? 'met ' + result.reserve + '% extra' : 'zonder extra ruimte') + ' geeft ' + balloons(result.planned) + ' om mee te rekenen. Dat is ' + format(result.tanks) + (result.tanks === 1 ? ' tank' : ' tanks') + ' volgens het maximum van 50 latexballonnen van 23 cm per tank.';
        }
      } else {
        var length = number('length');
        var sample = number('sample');
        var pieces = number('count');
        var spare = number('reserve');
        valid = field(form, 'length', Number.isFinite(length) && length > 0 && length <= 1000, 'Vul een lengte groter dan 0 en maximaal 1.000 meter in.') && valid;
        valid = field(form, 'sample', Number.isFinite(sample) && sample > 0 && sample <= 1000, 'Vul de lengte van je proefstuk in: groter dan 0 en maximaal 1.000 meter.') && valid;
        valid = field(form, 'count', Number.isInteger(pieces) && pieces >= 1 && pieces <= 100000, 'Vul een heel aantal van 1 tot en met 100.000 in.') && valid;
        valid = field(form, 'reserve', Number.isInteger(spare) && spare >= 0 && spare <= 100000, 'Vul een heel aantal extra ballonnen van 0 tot en met 100.000 in.') && valid;
        result = valid ? decor(length, sample, pieces, spare) : null;
        if (result) output.textContent = balloons(result.base) + ' + ' + format(result.reserve) + ' extra = ' + balloons(result.total) + ' klaarleggen. Verdeel dit aantal nog over je kleuren, maten en verpakkingen.';
      }
      output.classList.toggle('bk-calculator-result-error', !result);
      if (!result) {
        output.textContent = valid ? 'De berekende hoeveelheid is te groot. Controleer je lengtes en proefstuk; de uitkomst mag zonder extra ballonnen maximaal 1.000.000 ballonnen zijn.' : 'Controleer de gemarkeerde velden. Daarna verschijnt je berekening.';
        if (event && event.type === 'submit') {
          var invalid = form.querySelector('[aria-invalid="true"]');
          if (invalid) invalid.focus();
        }
      }
    }

    form.addEventListener('submit', update);
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.hidden = false;
    update();
  }

  function init(scope) {
    if (scope.matches && scope.matches('[data-bk-calculator]')) enable(scope);
    scope.querySelectorAll('[data-bk-calculator]').forEach(enable);
  }

  if (typeof module === 'object' && module.exports) module.exports = { decimal: decimal, helium: helium, decor: decor };
  if (typeof document === 'undefined') return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
